import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=50c90797&"
import script from "./UserPermissions.vue?vue&type=script&lang=ts&"
export * from "./UserPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports